/**
 * Bộ định tuyến. Nhóm màn hình quản lý thiết bị (MH-01 đến MH-06, MH-08) đã có
 * màn hình thật; các mục điều hướng còn lại giữ trang giữ chỗ cho đợt sau.
 *
 * Mọi tuyến nghiệp vụ đi qua `BaoVeTuyen`: truy cập trực tiếp bằng đường dẫn khi
 * không có quyền thì ra trang thông báo không có quyền, không phải trang trắng.
 */
import type { ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { KhungTrang } from '../khung/KhungTrang';
import { TrangCho, TrangKhongTimThay } from '../trang/TrangCho';
import { BaoVeTuyen } from './BaoVeTuyen';
import { QUYEN_DIEU_HUONG, QUYEN_MAN_HINH } from '../quyen/ma-tran-man-hinh';
import { MH01TongQuan } from '../man-hinh/MH01TongQuan';
import { MH02DanhSachThietBi } from '../man-hinh/MH02DanhSachThietBi';
import { MH03ChiTietThietBi } from '../man-hinh/MH03ChiTietThietBi';
import { MH04BieuMauThietBi } from '../man-hinh/MH04BieuMauThietBi';
import { MH05BanDoThietBi } from '../man-hinh/MH05BanDoThietBi';
import { MH06NhapKhau } from '../man-hinh/MH06NhapKhau';
import { MH11DanhSachBanTin } from '../man-hinh/MH11DanhSachBanTin';
import { MH12BienTapBanTin } from '../man-hinh/MH12BienTapBanTin';
import { MH13TaoTuVanBan } from '../man-hinh/MH13TaoTuVanBan';
import { MH14HangDoiDuyet } from '../man-hinh/MH14HangDoiDuyet';
import { MH14DuyetBanTin } from '../man-hinh/MH14DuyetBanTin';
import { MH15KhoAmThanh } from '../man-hinh/MH15KhoAmThanh';
import { MH16NgheLaiBanTin } from '../man-hinh/MH16NgheLaiBanTin';
import { MH17LichTuan } from '../man-hinh/MH17LichTuan';
import { MH18TaoSuaLichPhat } from '../man-hinh/MH18TaoSuaLichPhat';
import { LichPhatThanh } from '../man-hinh/LichPhatThanh';
import { DanhSachLichPhat } from '../man-hinh/DanhSachLichPhat';
import { MH19PhatNgay } from '../man-hinh/MH19PhatNgay';
import { MH20PhatKhanCap } from '../man-hinh/MH20PhatKhanCap';
import { MH21TiepSong } from '../man-hinh/MH21TiepSong';
import { MH22PhatTrucTiepMicro } from '../man-hinh/MH22PhatTrucTiepMicro';
import { MH23TheoDoiPhien } from '../man-hinh/MH23TheoDoiPhien';
import { MH24DanhSachBangTin, MH24ChiTietBangTin } from '../man-hinh/MH24BangTinDienTu';
import { NhatKyBanTinDaPhatBT, NhatKyHuyLichBT, NhatKyLichPhatBT } from '../man-hinh/BangTinNhatKy';
import { MH32BaoCaoDinhKy, MH32ChiTietKyBaoCao } from '../man-hinh/MH32BaoCaoDinhKy';
import { MH33ThongKe } from '../man-hinh/MH33ThongKe';
import { MH34NguoiDung } from '../man-hinh/MH34NguoiDung';
import { MH35NhomQuyen } from '../man-hinh/MH35NhomQuyen';
import { MH36DanhMucHanhChinh } from '../man-hinh/MH36DanhMucHanhChinh';
import { MH37LinhVucBanTin } from '../man-hinh/MH37LinhVucBanTin';
import { MH38NhatKyThaoTac } from '../man-hinh/MH38NhatKyThaoTac';
import { MH39DaTinh } from '../man-hinh/MH39DaTinh';
import { QuanTriNhaCungCap } from '../man-hinh/QuanTriNhaCungCap';
import { MH40HoSoCaNhan } from '../man-hinh/MH40HoSoCaNhan';
import { MH41ThietBiTinCayPhien } from '../man-hinh/MH41ThietBiTinCayPhien';
import { QuanTriThietBi } from '../man-hinh/QuanTriThietBi';
import { NhatKyHuyLichPhat } from '../man-hinh/NhatKyHuyLichPhat';
import { NhatKyLichPhatThietBi } from '../man-hinh/NhatKyLichPhatThietBi';
import { LichPhatBangTin, SoanLichBangTin } from '../man-hinh/LichPhatBangTin';
import { ThongKeBangDienTu } from '../man-hinh/ThongKeBangDienTu';
import { ChonLoaiNoiDung } from '../man-hinh/ChonLoaiNoiDung';
import { HuongDanSuDung } from '../man-hinh/HuongDanSuDung';
import { TrangChuaCoApi } from '../man-hinh/TrangChuaCoApi';
import { TrangThongBao } from '../man-hinh/TrangThongBao';
import { vi } from '../ngon-ngu/vi';

export interface BoDinhTuyenProps {
  hoTen?: string;
  tenTinh?: string;
  onDangXuat?: () => void;
}

export function BoDinhTuyen({ hoTen, tenTinh, onDangXuat }: BoDinhTuyenProps): ReactNode {
  return (
    <Routes>
      <Route path="/" element={<KhungTrang hoTen={hoTen} tenTinh={tenTinh} onDangXuat={onDangXuat} />}>
        <Route index element={<Navigate to="/tong-quan" replace />} />

        <Route
          path="tong-quan"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-01']}>
              <MH01TongQuan />
            </BaoVeTuyen>
          }
        />

        {/* Tuyến con của /thiet-bi phải khai TRƯỚC tuyến :id để "moi", "ban-do"
            và "nhap-khau" không bị hiểu thành mã thiết bị. */}
        <Route
          path="thiet-bi/moi"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-04']}>
              <MH04BieuMauThietBi />
            </BaoVeTuyen>
          }
        />
        <Route
          path="thiet-bi/ban-do"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-05']}>
              <MH05BanDoThietBi />
            </BaoVeTuyen>
          }
        />
        <Route
          path="thiet-bi/nhap-khau"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-06']}>
              <MH06NhapKhau />
            </BaoVeTuyen>
          }
        />
        <Route
          path="thiet-bi/:id/sua"
          element={
            <BaoVeTuyen quyen="device.update">
              <MH04BieuMauThietBi />
            </BaoVeTuyen>
          }
        />
        <Route
          path="thiet-bi/:id"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-03']}>
              <MH03ChiTietThietBi />
            </BaoVeTuyen>
          }
        />
        <Route
          path="thiet-bi"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-02']}>
              <MH02DanhSachThietBi />
            </BaoVeTuyen>
          }
        />

        {/* Tuyến con của /ban-tin phải khai TRƯỚC ":id" cùng lý do MH-02/04. */}
        <Route
          path="ban-tin/moi"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-12']}>
              <MH12BienTapBanTin />
            </BaoVeTuyen>
          }
        />
        <Route
          path="ban-tin/tao-tu-van-ban"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-13']}>
              <MH13TaoTuVanBan />
            </BaoVeTuyen>
          }
        />
        <Route
          path="ban-tin/duyet"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-14']}>
              <MH14HangDoiDuyet />
            </BaoVeTuyen>
          }
        />
        <Route
          path="ban-tin/duyet/:id"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-14']}>
              <MH14DuyetBanTin />
            </BaoVeTuyen>
          }
        />
        <Route
          path="ban-tin/:id/sua"
          element={
            <BaoVeTuyen quyen="bulletin.update">
              <MH12BienTapBanTin />
            </BaoVeTuyen>
          }
        />
        <Route
          path="ban-tin"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-11']}>
              <MH11DanhSachBanTin />
            </BaoVeTuyen>
          }
        />

        <Route
          path="kho-am-thanh"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-15']}>
              <MH15KhoAmThanh />
            </BaoVeTuyen>
          }
        />
        <Route
          path="nghe-lai"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-16']}>
              <MH16NgheLaiBanTin />
            </BaoVeTuyen>
          }
        />
        <Route
          path="tiep-song"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-21']}>
              <MH21TiepSong />
            </BaoVeTuyen>
          }
        />

        {/* "Lịch phát thanh" trên menu mở trang danh sách lịch theo mẫu; nút "Thêm mới
            lịch" dẫn tới trang soạn lịch /lich-phat/moi. Lịch tuần (MH-17) ở
            /lich-phat/tuan, biểu mẫu cũ MH-18 ở /lich-phat/nang-cao. */}
        <Route
          path="lich-phat/moi"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-18']}>
              <LichPhatThanh />
            </BaoVeTuyen>
          }
        />
        <Route
          path="lich-phat/:id/sua"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-18']}>
              <LichPhatThanh />
            </BaoVeTuyen>
          }
        />
        <Route
          path="lich-phat/nang-cao"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-18']}>
              <MH18TaoSuaLichPhat />
            </BaoVeTuyen>
          }
        />
        <Route
          path="lich-phat/tuan"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-17']}>
              <MH17LichTuan />
            </BaoVeTuyen>
          }
        />
        <Route
          path="lich-phat"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-17']}>
              <DanhSachLichPhat />
            </BaoVeTuyen>
          }
        />

        <Route
          path="phat-song/ngay"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-19']}>
              <MH19PhatNgay />
            </BaoVeTuyen>
          }
        />
        <Route
          path="phat-song/khan-cap"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-20']}>
              <MH20PhatKhanCap />
            </BaoVeTuyen>
          }
        />
        <Route
          path="phat-song/truc-tiep"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-22']}>
              <MH22PhatTrucTiepMicro />
            </BaoVeTuyen>
          }
        />
        <Route
          path="phat-song/phien/:phienId"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-23']}>
              <MH23TheoDoiPhien />
            </BaoVeTuyen>
          }
        />

        {/* Menu "Bảng điện tử công cộng" (API /api/v1/digital-signage, tách khỏi cụm
            loa — hợp đồng A0 bảng tin mục 5): MH-24 danh sách thiết bị + chi tiết,
            lịch phát (danh sách + soạn), ba trang nhật ký DV013/DV014/DV015. Bản tin
            dùng chung Kho nội dung /ban-tin (hợp đồng gộp kho 29/10/2026). Tuyến con khai TRƯỚC ":id" cùng lý do MH-02/MH-04. */}
        <Route
          path="bang-tin-dien-tu/lich-phat/moi"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-26']}>
              <SoanLichBangTin />
            </BaoVeTuyen>
          }
        />
        <Route
          path="bang-tin-dien-tu/lich-phat/:id/sua"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-26']}>
              <SoanLichBangTin />
            </BaoVeTuyen>
          }
        />
        <Route
          path="bang-tin-dien-tu/:id"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-24']}>
              <MH24ChiTietBangTin />
            </BaoVeTuyen>
          }
        />
        <Route
          path="bang-tin-dien-tu"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-24']}>
              <MH24DanhSachBangTin />
            </BaoVeTuyen>
          }
        />

        {/* /bao-cao/:id phải khai TRƯỚC /bao-cao cùng lý do MH-02/MH-04. */}
        <Route
          path="bao-cao/:id"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-32']}>
              <MH32ChiTietKyBaoCao />
            </BaoVeTuyen>
          }
        />
        <Route
          path="bao-cao"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-32']}>
              <MH32BaoCaoDinhKy />
            </BaoVeTuyen>
          }
        />
        <Route
          path="thong-ke"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-33']}>
              <MH33ThongKe />
            </BaoVeTuyen>
          }
        />

        {/* Đợt 3 phần C4 — danh mục: hành chính (mặc định) + lĩnh vực bản tin. */}
        <Route
          path="danh-muc/linh-vuc"
          element={
            <BaoVeTuyen quyen="catalog.manage">
              <MH37LinhVucBanTin />
            </BaoVeTuyen>
          }
        />
        <Route
          path="danh-muc"
          element={
            <BaoVeTuyen quyen="catalog.manage">
              <MH36DanhMucHanhChinh />
            </BaoVeTuyen>
          }
        />

        {/* Đợt 3 phần C4 — quản trị: người dùng (mặc định), nhóm quyền, nhật ký
            thao tác, quản trị đa tỉnh, hồ sơ cá nhân, phiên đăng nhập. Gộp dưới
            /quan-tri đã có sẵn trong điều hướng — KHÔNG thêm mục điều hướng mới
            (giữ nguyên 10 mục hiện có, xem NOTES-A0.md mục Z3-C4). */}
        <Route
          path="quan-tri/nhom-quyen"
          element={
            <BaoVeTuyen quyen="user.manage">
              <MH35NhomQuyen />
            </BaoVeTuyen>
          }
        />
        <Route
          path="quan-tri/nhat-ky"
          element={
            <BaoVeTuyen quyen="audit.read">
              <MH38NhatKyThaoTac />
            </BaoVeTuyen>
          }
        />
        <Route
          path="quan-tri/nha-cung-cap"
          element={
            <BaoVeTuyen quyen={QUYEN_DIEU_HUONG['/quan-tri/nha-cung-cap'] ?? 'vendor.manage'}>
              <QuanTriNhaCungCap />
            </BaoVeTuyen>
          }
        />
        <Route
          path="quan-tri/da-tinh"
          element={
            <BaoVeTuyen quyen="platform.manage">
              <MH39DaTinh />
            </BaoVeTuyen>
          }
        />
        <Route path="quan-tri/ho-so" element={<MH40HoSoCaNhan />} />
        <Route path="quan-tri/phien" element={<MH41ThietBiTinCayPhien />} />
        <Route
          path="quan-tri"
          element={
            <BaoVeTuyen quyen="user.manage">
              <MH34NguoiDung />
            </BaoVeTuyen>
          }
        />

        {/* ----- Trang theo menu của bản mẫu CMS "Thông tin nguồn" ----- */}
        <Route
          path="lich-phat/da-huy"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-17']}>
              <NhatKyHuyLichPhat />
            </BaoVeTuyen>
          }
        />
        <Route
          path="lich-phat/nhat-ky-gui"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-17']}>
              <NhatKyLichPhatThietBi />
            </BaoVeTuyen>
          }
        />
        <Route
          path="bang-tin-dien-tu/lich-phat"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-24']}>
              <LichPhatBangTin />
            </BaoVeTuyen>
          }
        />
        <Route
          path="bang-tin-dien-tu/thong-ke"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-33']}>
              <ThongKeBangDienTu />
            </BaoVeTuyen>
          }
        />
        <Route
          path="bang-tin-dien-tu/nhat-ky-ban-tin"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-24']}>
              <NhatKyBanTinDaPhatBT />
            </BaoVeTuyen>
          }
        />
        <Route
          path="bang-tin-dien-tu/nhat-ky-lich"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-24']}>
              <NhatKyLichPhatBT />
            </BaoVeTuyen>
          }
        />
        <Route
          path="bang-tin-dien-tu/nhat-ky-huy"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-24']}>
              <NhatKyHuyLichBT />
            </BaoVeTuyen>
          }
        />
        <Route
          path="bao-cao/nhan-duyet"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-32']}>
              <MH32BaoCaoDinhKy cheDo="nhan-duyet" />
            </BaoVeTuyen>
          }
        />
        <Route
          path="ban-tin/xuat-ban"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-11']}>
              <MH11DanhSachBanTin cheDo="xuat-ban" />
            </BaoVeTuyen>
          }
        />
        <Route
          path="ban-tin/kho-nguon"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-11']}>
              <MH11DanhSachBanTin cheDo="kho-nguon" />
            </BaoVeTuyen>
          }
        />
        <Route
          path="ban-tin/chon-loai"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-12']}>
              <ChonLoaiNoiDung />
            </BaoVeTuyen>
          }
        />
        <Route
          path="quan-tri/cum-loa"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-04']}>
              <QuanTriThietBi loai="cum_thu_phat_thanh" />
            </BaoVeTuyen>
          }
        />
        <Route
          path="quan-tri/bang-dien-tu"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-25']}>
              <QuanTriThietBi loai="bang_tin_dien_tu" />
            </BaoVeTuyen>
          }
        />
        <Route
          path="quan-tri/bao-cao-dong"
          element={
            <BaoVeTuyen quyen={QUYEN_MAN_HINH['MH-32']}>
              <TrangChuaCoApi ma="bao-cao-dong" />
            </BaoVeTuyen>
          }
        />
        <Route
          path="quan-tri/nhat-ky/:nhom"
          element={
            <BaoVeTuyen quyen="audit.read">
              <MH38NhatKyThaoTac />
            </BaoVeTuyen>
          }
        />
        <Route path="huong-dan" element={<HuongDanSuDung />} />
        <Route path="thong-bao" element={<TrangThongBao />} />

        {/* Chưa có màn hình nghiệp vụ: trang giữ chỗ. */}
        <Route path="tich-hop" element={<TrangCho tieuDe={vi.dieuHuong.tichHop} />} />
        <Route path="phat-song" element={<TrangCho tieuDe={vi.dieuHuong.phatSong} />} />

        <Route path="*" element={<TrangKhongTimThay />} />
      </Route>
    </Routes>
  );
}
